export const Size = {
  CONTENT_WIDTH: 536,
  TABLET_WIDTH: 768,
};
